import {
  Box,
  Button,
  Dialog,
  Grid,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { grey } from "@mui/material/colors";
import { OnboardingDialogsContext } from "contexts/OnboardingDialogs";
import { OrganizationUserContext } from "contexts/Organization";
import { useContext, useEffect } from "react";

import {
  INSTAGRAM_FOLLOWED,
  INSTAGRAM_JOINED_CHANNEL,
} from "utils/localStorage";
import { trackEvent } from "utils/tracking";

const styles = {
  chip: {
    px: 2,
    backgroundColor: "white",
    borderRadius: 4,
    py: 1,
    color: "primary.dark",
    fontSize: 16,
    width: "fit-content",
    mx: "auto",
  },
};

const InstagramOnboardingDialog = () => {
  const { currentOrg } = useContext(OrganizationUserContext);
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down("md"));
  const {
    instagramOnboardingDialogOpen,
    setInstagramOnboardingDialogOpen,
    setCreateTemplateOnboardingDialogOpen,
  } = useContext(OnboardingDialogsContext);

  const handleClose = () => {
    setInstagramOnboardingDialogOpen(false);
    setCreateTemplateOnboardingDialogOpen(true);
  };

  useEffect(() => {
    if (instagramOnboardingDialogOpen) {
      trackEvent("Instagram Dialog - Opened");
    }
  }, [instagramOnboardingDialogOpen]);
  return (
    <Dialog
      maxWidth="sm"
      open={instagramOnboardingDialogOpen}
      onClose={handleClose}
      fullScreen={isMobileScreen}
      PaperProps={{
        sx: {
          background:
            "linear-gradient(57.59deg, #151F16 -1.58%, #004537 98.35%), linear-gradient(180deg, rgba(236, 234, 229, 0) 0%, #ECEAE5 100%), #FFFFFF;",
          borderRadius: { xs: 0, md: 4 },
        },
      }}
    >
      <Grid container justifyContent="flex-end" sx={{ pr: 1, pt: 1 }}>
        <IconButton>
          <Box
            component="i"
            className="fa-thin fa-xmark"
            sx={{ color: grey[600] }}
            onClick={handleClose}
          />
        </IconButton>
      </Grid>

      <Box sx={{ p: 6, mt: -6 }}>
        <Box sx={styles.chip}>🚀 Land brand deals</Box>

        <Typography
          textAlign={"center"}
          sx={{ my: 2, fontSize: 22, color: "yellow.main" }}
        >
          Connect with Bento on Instagram
        </Typography>

        <Typography sx={{ color: "white" }} textAlign={"center"}>
          Follow us on Instagram and join our exclusive broadcast channel for
          insider tips, updates, and tips for landing brand deals
        </Typography>

        <Grid container justifyContent={"center"} sx={{ mt: 3 }} gap={1}>
          <Button
            sx={{
              px: 3,
              py: 1,
              border: `1px solid white`,
              color: "white",
              "&:hover": {
                border: `1px solid`,
                color: "green.main",
                borderColor: "green.main",
              },
            }}
            href="https://www.instagram.com/onbento/"
            target="_blank"
            onClick={() => {
              trackEvent(
                "Instagram Dialog - Followed on Instagram Button Clicked",
              );
              localStorage.setItem(
                `${INSTAGRAM_FOLLOWED}-${currentOrg?.id}`,
                "true",
              );
            }}
          >
            <Box
              component="i"
              className="fa-brands fa-instagram"
              sx={{ mr: 1 }}
            />
            Follow @onbento
          </Button>
          <Button
            sx={{
              px: 4,
              py: 1,
              backgroundColor: "yellow.main",
              color: "primary.dark",
              "&:hover": {
                backgroundColor: "#F7FCBD",
              },
            }}
            href="https://www.instagram.com/channel/AbbB2dMJECaKLBRZ/"
            target="_blank"
            onClick={() => {
              trackEvent(
                "Instagram Dialog - Joined Instagram Channel Button Clicked",
              );
              localStorage.setItem(
                `${INSTAGRAM_JOINED_CHANNEL}-${currentOrg?.id}`,
                "true",
              );
            }}
          >
            Join Our Channel
          </Button>
        </Grid>
      </Box>
    </Dialog>
  );
};

export default InstagramOnboardingDialog;
